import { FormattedAmount } from 'components';
import { useTranslations } from 'utils';
import './CouponSummary.scss';

interface Amount {
  value: number;
  currency: string;
}

interface CouponSummaryProps {
  originalAmount: Amount;
  discountAmount: Amount;
  totalAmount: Amount;
}

function CouponSummary({
  originalAmount,
  discountAmount,
  totalAmount,
}: CouponSummaryProps) {
  const i18n = useTranslations();

  return (
    <div className="EnterCoupon-summary" data-testid="enterCouponOrderSummary">
      <div className="EnterCoupon-summary--content">
        <div className="EnterCoupon-summary--labels">
          <span>
            {i18n.t('coupon.enterCoupon.summary.originalPaymentAmount')}
          </span>
          <span>{i18n.t('coupon.enterCoupon.summary.discountCode')}</span>
        </div>
        <div className="EnterCoupon-summary--values">
          <span>
            <FormattedAmount
              value={originalAmount.value}
              currency={originalAmount.currency}
            />
          </span>
          <span className="EnterCoupon-summary--values--discount">
            <FormattedAmount
              value={discountAmount.value}
              currency={discountAmount.currency}
            />
          </span>
        </div>
      </div>
      <div className="EnterCoupon-summary--total">
        <span className="EnterCoupon-summary--total--labels">
          {i18n.t('coupon.enterCoupon.summary.totalPaymentAmount')}
        </span>
        <span className="EnterCoupon-summary--total--value">
          <FormattedAmount
            value={totalAmount.value}
            currency={totalAmount.currency}
          />
        </span>
      </div>
    </div>
  );
}

export { CouponSummary };
